<ng-container [ngSwitch]="desktopTemplate">
    <ng-container *ngSwitchCase="'xs'" [ngTemplateOutlet]="modesmall"></ng-container>
    <ng-container *ngSwitchCase="'sm'" [ngTemplateOutlet]="modesmall"></ng-container>
    <ng-container *ngSwitchCase="'md'" [ngTemplateOutlet]="modesmall"></ng-container>
    <ng-container *ngSwitchDefault [ngTemplateOutlet]="modelgxl"></ng-container>
</ng-container>

<ng-template #modesmall>
    <div class="contentwrapperMobile">
        <div class="contentwrapper">

            <div class="descriptionMobile">
                <div class="titlewrapper">
                    <span multilang class="destitlemobile">Überblick</span>
                </div>
                <div class="uberwrapperMobile">
                    <ul>
                        <li>
                            <div class="ubercontentwrapper">
                                <svg width="16" height="16" viewBox="0 0 32 32" icon="bedrooms-1"
                                    class="fxsh0 w16 h16 f-gray-extra-dark">
                                    <path d="M17.148 14.889v4.296h2V14.89h-2Z"></path>
                                    <path fill-rule="evenodd"
                                        d="M25.236 1.234A.996.996 0 0 0 24.594 1H7.407a1 1 0 0 0-1 1v23.704H.963v2h6.444a1 1 0 0 0 1-1V3H19.88l-5.36 2.382a1 1 0 0 0-.594.914V31a1 1 0 0 0 1.406.914l9.473-4.21h6.232v-2h-5.444V2a1 1 0 0 0-.357-.766Zm-9.31 5.712 7.667-3.407v22.515l-7.667 3.407V6.946Z"
                                        clip-rule="evenodd"></path>
                                </svg>
                                <span multilang class="ubtt"> {{ferienHauser?.bedrooms}} Schlafzimmer</span>
                            </div>
                        </li>
                        <li>
                            <div class="ubercontentwrapper">
                                <svg width="16" height="16" viewBox="0 0 32 32" icon="guests"
                                    class="fxsh0 w16 h16 f-gray-extra-dark">
                                    <path fill-rule="evenodd"
                                        d="M16 2a6.357 6.357 0 0 0-6.347 5.991 4.214 4.214 0 1 0 1.806 4.815A6.338 6.338 0 0 0 16 14.714c1.779 0 3.387-.73 4.54-1.908a4.216 4.216 0 0 0 8.245-1.235 4.214 4.214 0 0 0-6.438-3.58A6.357 6.357 0 0 0 16 2Zm-4.357 6.357a4.357 4.357 0 1 1 8.714 0 4.357 4.357 0 0 1-8.714 0Zm-6.429 3.214a2.214 2.214 0 1 1 4.429 0 2.214 2.214 0 0 1-4.429 0Zm19.357-2.214a2.214 2.214 0 1 0 0 4.429 2.214 2.214 0 0 0 0-4.43Z"
                                        clip-rule="evenodd"></path>
                                    <path fill-rule="evenodd"
                                        d="M8.385 17.759c-.317.028-.638.045-.956.045-.819 0-1.654-.11-2.382-.249-1.595-.305-3.37.517-3.92 2.2L.643 21.23c-.489 1.494.222 3.266 1.95 3.671.81.19 1.852.373 3.105.466-.064 1.217.598 2.433 1.892 2.867 1.676.561 4.547 1.266 8.41 1.266 3.863 0 6.734-.705 8.409-1.267 1.293-.434 1.956-1.65 1.892-2.867a20.105 20.105 0 0 0 3.106-.466c1.727-.405 2.438-2.177 1.949-3.671l-.482-1.473c-.551-1.684-2.326-2.506-3.92-2.2a12.94 12.94 0 0 1-2.382.248c-.32 0-.64-.017-.957-.045-1.427-1.355-3.54-1.959-5.491-1.683-.694.097-1.413.158-2.124.158-.711 0-1.43-.06-2.124-.159-1.951-.275-4.065.329-5.491 1.684Zm-2.26 5.63.73-2.998c.049-.204.11-.403.18-.594a15.526 15.526 0 0 1-2.364-.277c-.755-.145-1.45.269-1.644.858l-.482 1.473c-.188.576.111 1.01.506 1.102.772.182 1.806.36 3.073.437Zm18.84-3.592c.07.191.13.39.18.594l.73 2.999a18.32 18.32 0 0 0 3.075-.437c.394-.092.694-.526.505-1.102l-.482-1.473c-.193-.59-.889-1.003-1.643-.858-.7.133-1.519.248-2.366.277ZM8.796 20.864c.463-1.9 2.6-3.118 4.8-2.808.766.108 1.58.178 2.403.178.822 0 1.637-.07 2.403-.178 2.2-.31 4.337.909 4.8 2.808l1.072 4.408c.128.526-.13.94-.502 1.065-1.5.503-4.156 1.163-7.773 1.163-3.618 0-6.273-.66-7.773-1.163-.372-.125-.63-.54-.502-1.065l1.072-4.408Z"
                                        clip-rule="evenodd"></path>
                                </svg>
                                <span multilang class="ubtt">max. {{ferienHauser?.guests}} Gäste</span>
                            </div>
                        </li>
                        <li>
                            <div class="ubercontentwrapper">
                                <svg width="16" height="16" viewBox="0 0 50 50" icon="house"
                                    class="fxsh0 w16 h16 f-gray-extra-dark">
                                    <path fill-rule="evenodd"
                                        d="M27.485 1.018a4.647 4.647 0 0 0-5.806 0L1.744 16.966A4.647 4.647 0 0 0 0 20.595v24.647a4.647 4.647 0 0 0 4.647 4.647h39.87a4.647 4.647 0 0 0 4.647-4.647V20.595a4.647 4.647 0 0 0-1.744-3.629L27.485 1.018Zm-4.057 2.187a1.847 1.847 0 0 1 2.308 0L45.67 19.153c.439.35.694.88.694 1.442v24.647c0 1.02-.827 1.847-1.847 1.847h-10.08v-14.99a4.647 4.647 0 0 0-4.648-4.647H18.283a4.647 4.647 0 0 0-4.647 4.647v14.99H4.647A1.847 1.847 0 0 1 2.8 45.242V20.595c0-.561.255-1.092.693-1.442L23.428 3.205Zm-6.992 43.884h15.2v-14.99c0-1.02-.827-1.847-1.847-1.847H18.283c-1.02 0-1.847.827-1.847 1.847v14.99Z"
                                        clip-rule="evenodd"></path>
                                </svg>
                                <span multilang class="ubtt">{{ferienHauser?.type}}</span>
                            </div>
                        </li>
                        <li>
                            <div class="ubercontentwrapper">
                                <svg width="16" height="16" viewBox="0 0 32 32" icon="Size"
                                    class="fxsh0 w16 h16 f-gray-extra-dark">
                                    <path
                                        d="m6 4.414 2.293 2.293 1.414-1.414-4-4a1 1 0 0 0-1.414 0l-4 4 1.414 1.414L4 4.414v13.172l-2.293-2.293-1.414 1.414 4 4a1 1 0 0 0 1.414 0l4-4-1.414-1.414L6 17.586V4.414Z">
                                    </path>
                                    <path fill-rule="evenodd"
                                        d="M11 3.333A2.333 2.333 0 0 1 13.333 1h15.334A2.333 2.333 0 0 1 31 3.333v15.334A2.333 2.333 0 0 1 28.667 21H13.333A2.333 2.333 0 0 1 11 18.667V3.333ZM13.333 3a.333.333 0 0 0-.333.333v15.334c0 .184.15.333.333.333h15.334c.184 0 .333-.15.333-.333V3.333A.333.333 0 0 0 28.667 3H13.333Z"
                                        clip-rule="evenodd"></path>
                                    <path
                                        d="M25.293 23.707 27.586 26H14.414l2.293-2.293-1.414-1.414-4 4a1 1 0 0 0 0 1.414l4 4 1.414-1.414L14.414 28h13.172l-2.293 2.293 1.414 1.414 4-4a1 1 0 0 0 0-1.414l-4-4-1.414 1.414Z">
                                    </path>
                                </svg>
                                <span multilang class="ubtt">{{ferienHauser?.size}} m²</span>
                            </div>
                        </li>
                        <li>
                            <div class="ubercontentwrapper">
                                <svg width="16" height="16" viewBox="0 0 32 32" icon="bath"
                                    class="fxsh0 w16 h16 f-gray-extra-dark">
                                    <path fill-rule="evenodd"
                                        d="M3.758 32.018V6.28a3.68 3.68 0 0 1 7.165-1.185 8.02 8.02 0 0 0-3.662 10.552l.495 1.06a1 1 0 0 0 1.329.484l12.723-5.933a1 1 0 0 0 .484-1.329l-.494-1.06a8.023 8.023 0 0 0-8.99-4.445A5.682 5.682 0 0 0 1.758 6.28v25.738h2ZM19.985 9.714l.072.154-10.911 5.088-.072-.154a6.02 6.02 0 0 1 10.911-5.088Z"
                                        clip-rule="evenodd"></path>
                                    <path
                                        d="m15.794 17.778.885 2.429-1.88.684-.884-2.429 1.88-.684Zm2.481 6.848-.884-2.43-1.88.685.885 2.429 1.88-.684Zm.713 1.989.884 2.43-1.88.683-.884-2.429 1.88-.684Zm1.981-8.6-1.293-2.24-1.732 1 1.293 2.24 1.732-1Zm1.058 1.828 1.292 2.239-1.732 1-1.292-2.239 1.732-1Zm3.642 6.307-1.293-2.24-1.732 1 1.292 2.24 1.733-1ZM23.61 13.259l1.483 2.117-1.638 1.147-1.483-2.117 1.638-1.147Zm4.214 6.007-1.483-2.117-1.638 1.147 1.483 2.117 1.638-1.147Zm1.238 1.778 1.482 2.117-1.638 1.147-1.482-2.117 1.638-1.147Zm-17.002.793-.67-2.497-1.931.518.669 2.497 1.931-.518Zm.556 2.095.67 2.497-1.932.518-.67-2.497 1.932-.518Zm1.894 7.089-.668-2.497-1.932.518.669 2.497 1.932-.518Z">
                                    </path>
                                </svg>
                                <span multilang class="ubtt">{{ferienHauser?.bathrooms}} Badezimmer</span>
                            </div>
                        </li>
                        <li>
                            <div class="ubercontentwrapper">
                                @if(!ferienHauser?.petFriendly) {
                                <svg width="16" height="16" viewBox="0 0 32 32" icon="no_dogs"
                                    class="fxsh0 w16 h16 f-gray-extra-dark">
                                    <path d="m2.293 3.707 26 26 1.414-1.414-26-26-1.414 1.414Z"></path>
                                    <path fill-rule="evenodd"
                                        d="m22.737 19.201.23-2.753 1.34-1.34 3.45.862a1 1 0 0 0 1.075-.415l2-3a1 1 0 0 0-.277-1.387l-5.476-3.65.411-2.877a1 1 0 0 0-.747-1.111l-2-.5a1 1 0 0 0-1.127.502l-4.282 8.088-1.794.385 1.684 1.684.865-.185 2.876 2.875-.08.97 1.852 1.852ZM22 14.586l-2.598-2.598 3.615-6.828.366.091-.373 2.608a1 1 0 0 0 .435.973l5.168 3.445-1.054 1.582-3.317-.83a1 1 0 0 0-.95.264L22 14.586Z"
                                        clip-rule="evenodd"></path>
                                    <path
                                        d="m22.193 25.728-1.853-1.852L20.08 27h-2.233l-.86-5.164A1 1 0 0 0 16 21h-6a1 1 0 0 0-.986.836L8.153 27h-2.23l-.856-10.706 6.334-1.357-1.684-1.685-5.345 1.146-2.613-3.049-1.518 1.302 2.788 3.253.974 12.176A1 1 0 0 0 5 29h4a1 1 0 0 0 .986-.836L10.847 23h4.306l.86 5.164A1 1 0 0 0 17 29h4a1 1 0 0 0 .997-.917l.196-2.355Z">
                                    </path>
                                </svg>
                                <span multilang class="ubtt">Haustiere nicht gestattet</span>
                                } @else {
                                <svg width="16" height="16" viewBox="0 0 32 32" icon="pets_allowed"
                                    class="fxsh0 w16 h16 f-gray-extra-dark">
                                    <path fill-rule="evenodd"
                                        d="M21.616 3.532a1 1 0 0 1 1.127-.502l2 .5a1 1 0 0 1 .747 1.111l-.41 2.877 5.475 3.65a1 1 0 0 1 .277 1.387l-2 3a1 1 0 0 1-1.075.415l-3.45-.863-1.34 1.341-.97 11.635A1 1 0 0 1 21 29h-4a1 1 0 0 1-.986-.836L15.153 23h-4.306l-.86 5.164A1 1 0 0 1 9 29H5a1 1 0 0 1-.997-.92L3.03 15.904.241 12.65l1.518-1.302 2.613 3.049 12.962-2.778 4.282-8.088Zm-2.214 8.456L22 14.586l1.293-1.293a1 1 0 0 1 .95-.263l3.316.829 1.054-1.582-5.168-3.445a1 1 0 0 1-.435-.973l.372-2.608-.365-.09-3.615 6.827Zm1.563 4.391-2.876-2.875-13.022 2.79L5.923 27h2.23l.86-5.164A1 1 0 0 1 10 21h6a1 1 0 0 1 .986.836L17.847 27h2.233l.885-10.62Z"
                                        clip-rule="evenodd"></path>
                                </svg>
                                <span multilang class="ubtt">Haustiere erlaubt</span>
                                }
                            </div>
                        </li>
                    </ul>
                </div>
            </div>

            <div class="descriptionMobile">
                <div class="titlewrapper">
                    <span multilang class="destitlemobile">Ausstattung</span>
                </div>
                <div class="uberwrapperMobile">
                    <ul>
                        @for (item of ferienHauser?.amenities; track $index) {
                        @if(amenities[item].text?.length > 0) {
                        <li>
                            <div class="ubercontentwrapper">
                                <div multilang deeplMode='html' [innerHtml]="amenities[item].ico| safehtml"></div>
                                <span multilang class="ubtt"> {{amenities[item].text}}</span>
                            </div>
                        </li>
                        }
                        }
                    </ul>
                </div>
            </div>

            <div class="descriptionMobile">
                <div class="titlewrapper">
                    <span multilang class="destitlemobile">Beschreibung</span>
                </div>
                <div class="desccontainer">
                    <div [class.small]="!showMore">
                        <div class="f1rem" multilang deeplMode='html' [innerHtml]="ferienHauser?.description">
                        </div>
                        <div class="deco" *ngIf="!showMore"></div>
                    </div>
                    <div class="moreShowwrapper noselect" (click)="showMoreDesc()">
                        <ng-container *ngIf="!showMore else showless">
                            <span multilang>Mehr anzeigen</span>
                            <mat-icon>expand_more</mat-icon>
                        </ng-container>

                        <ng-template #showless>
                            <span multilang>Weniger anzeigen</span>
                            <mat-icon>expand_less</mat-icon>
                        </ng-template>
                    </div>
                </div>
            </div>

            <div class="descriptionMobile">
                <div class="titlewrapper">
                    <span multilang class="destitlemobile">Lage</span>
                </div>
                <div class="desccontainermobile">
                    <ng-container *ngTemplateOutlet="lage">
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #modelgxl>
    <div class="contentwrapper">
        <span multilang class="title">{{ferienHauser?.originalTitle?.length > 0 ? ferienHauser?.originalTitle :
            ferienHauser?.title }}</span>
        <div class="locationwrapper" (click)="gotoMap()">
            <mat-icon class="locationicon">place</mat-icon>
            <span multilang>{{ ferienHauser?.locationTrail?.[0]?.name }}, {{ ferienHauser?.locationTrail?.[2]?.name
                }}</span>
        </div>

        <div class="description">
            <div class="titlewrapper">
                <span multilang class="destitle">Überblick</span>
            </div>
            <div class="uberwrapper">
                <ul>
                    <li>
                        <div class="ubercontentwrapper">
                            <svg width="16" height="16" viewBox="0 0 32 32" icon="bedrooms-1"
                                class="fxsh0 w16 h16 f-gray-extra-dark">
                                <path d="M17.148 14.889v4.296h2V14.89h-2Z"></path>
                                <path fill-rule="evenodd"
                                    d="M25.236 1.234A.996.996 0 0 0 24.594 1H7.407a1 1 0 0 0-1 1v23.704H.963v2h6.444a1 1 0 0 0 1-1V3H19.88l-5.36 2.382a1 1 0 0 0-.594.914V31a1 1 0 0 0 1.406.914l9.473-4.21h6.232v-2h-5.444V2a1 1 0 0 0-.357-.766Zm-9.31 5.712 7.667-3.407v22.515l-7.667 3.407V6.946Z"
                                    clip-rule="evenodd"></path>
                            </svg>
                            <span multilang class="ubtt"> {{ferienHauser?.bedrooms}} Schlafzimmer</span>
                        </div>
                    </li>
                    <li>
                        <div class="ubercontentwrapper">
                            <svg width="16" height="16" viewBox="0 0 32 32" icon="guests"
                                class="fxsh0 w16 h16 f-gray-extra-dark">
                                <path fill-rule="evenodd"
                                    d="M16 2a6.357 6.357 0 0 0-6.347 5.991 4.214 4.214 0 1 0 1.806 4.815A6.338 6.338 0 0 0 16 14.714c1.779 0 3.387-.73 4.54-1.908a4.216 4.216 0 0 0 8.245-1.235 4.214 4.214 0 0 0-6.438-3.58A6.357 6.357 0 0 0 16 2Zm-4.357 6.357a4.357 4.357 0 1 1 8.714 0 4.357 4.357 0 0 1-8.714 0Zm-6.429 3.214a2.214 2.214 0 1 1 4.429 0 2.214 2.214 0 0 1-4.429 0Zm19.357-2.214a2.214 2.214 0 1 0 0 4.429 2.214 2.214 0 0 0 0-4.43Z"
                                    clip-rule="evenodd"></path>
                                <path fill-rule="evenodd"
                                    d="M8.385 17.759c-.317.028-.638.045-.956.045-.819 0-1.654-.11-2.382-.249-1.595-.305-3.37.517-3.92 2.2L.643 21.23c-.489 1.494.222 3.266 1.95 3.671.81.19 1.852.373 3.105.466-.064 1.217.598 2.433 1.892 2.867 1.676.561 4.547 1.266 8.41 1.266 3.863 0 6.734-.705 8.409-1.267 1.293-.434 1.956-1.65 1.892-2.867a20.105 20.105 0 0 0 3.106-.466c1.727-.405 2.438-2.177 1.949-3.671l-.482-1.473c-.551-1.684-2.326-2.506-3.92-2.2a12.94 12.94 0 0 1-2.382.248c-.32 0-.64-.017-.957-.045-1.427-1.355-3.54-1.959-5.491-1.683-.694.097-1.413.158-2.124.158-.711 0-1.43-.06-2.124-.159-1.951-.275-4.065.329-5.491 1.684Zm-2.26 5.63.73-2.998c.049-.204.11-.403.18-.594a15.526 15.526 0 0 1-2.364-.277c-.755-.145-1.45.269-1.644.858l-.482 1.473c-.188.576.111 1.01.506 1.102.772.182 1.806.36 3.073.437Zm18.84-3.592c.07.191.13.39.18.594l.73 2.999a18.32 18.32 0 0 0 3.075-.437c.394-.092.694-.526.505-1.102l-.482-1.473c-.193-.59-.889-1.003-1.643-.858-.7.133-1.519.248-2.366.277ZM8.796 20.864c.463-1.9 2.6-3.118 4.8-2.808.766.108 1.58.178 2.403.178.822 0 1.637-.07 2.403-.178 2.2-.31 4.337.909 4.8 2.808l1.072 4.408c.128.526-.13.94-.502 1.065-1.5.503-4.156 1.163-7.773 1.163-3.618 0-6.273-.66-7.773-1.163-.372-.125-.63-.54-.502-1.065l1.072-4.408Z"
                                    clip-rule="evenodd"></path>
                            </svg>
                            <span multilang class="ubtt">max. {{ferienHauser?.guests}} Gäste</span>
                        </div>
                    </li>
                    <li>
                        <div class="ubercontentwrapper">
                            <svg width="16" height="16" viewBox="0 0 50 50" icon="house"
                                class="fxsh0 w16 h16 f-gray-extra-dark">
                                <path fill-rule="evenodd"
                                    d="M27.485 1.018a4.647 4.647 0 0 0-5.806 0L1.744 16.966A4.647 4.647 0 0 0 0 20.595v24.647a4.647 4.647 0 0 0 4.647 4.647h39.87a4.647 4.647 0 0 0 4.647-4.647V20.595a4.647 4.647 0 0 0-1.744-3.629L27.485 1.018Zm-4.057 2.187a1.847 1.847 0 0 1 2.308 0L45.67 19.153c.439.35.694.88.694 1.442v24.647c0 1.02-.827 1.847-1.847 1.847h-10.08v-14.99a4.647 4.647 0 0 0-4.648-4.647H18.283a4.647 4.647 0 0 0-4.647 4.647v14.99H4.647A1.847 1.847 0 0 1 2.8 45.242V20.595c0-.561.255-1.092.693-1.442L23.428 3.205Zm-6.992 43.884h15.2v-14.99c0-1.02-.827-1.847-1.847-1.847H18.283c-1.02 0-1.847.827-1.847 1.847v14.99Z"
                                    clip-rule="evenodd"></path>
                            </svg>
                            <span multilang class="ubtt">{{ferienHauser?.type}}</span>
                        </div>
                    </li>
                    <li>
                        <div class="ubercontentwrapper">
                            <svg width="16" height="16" viewBox="0 0 32 32" icon="Size"
                                class="fxsh0 w16 h16 f-gray-extra-dark">
                                <path
                                    d="m6 4.414 2.293 2.293 1.414-1.414-4-4a1 1 0 0 0-1.414 0l-4 4 1.414 1.414L4 4.414v13.172l-2.293-2.293-1.414 1.414 4 4a1 1 0 0 0 1.414 0l4-4-1.414-1.414L6 17.586V4.414Z">
                                </path>
                                <path fill-rule="evenodd"
                                    d="M11 3.333A2.333 2.333 0 0 1 13.333 1h15.334A2.333 2.333 0 0 1 31 3.333v15.334A2.333 2.333 0 0 1 28.667 21H13.333A2.333 2.333 0 0 1 11 18.667V3.333ZM13.333 3a.333.333 0 0 0-.333.333v15.334c0 .184.15.333.333.333h15.334c.184 0 .333-.15.333-.333V3.333A.333.333 0 0 0 28.667 3H13.333Z"
                                    clip-rule="evenodd"></path>
                                <path
                                    d="M25.293 23.707 27.586 26H14.414l2.293-2.293-1.414-1.414-4 4a1 1 0 0 0 0 1.414l4 4 1.414-1.414L14.414 28h13.172l-2.293 2.293 1.414 1.414 4-4a1 1 0 0 0 0-1.414l-4-4-1.414 1.414Z">
                                </path>
                            </svg>
                            <span multilang class="ubtt">{{ferienHauser?.size}} m²</span>
                        </div>
                    </li>
                    <li>
                        <div class="ubercontentwrapper">
                            <svg width="16" height="16" viewBox="0 0 32 32" icon="bath"
                                class="fxsh0 w16 h16 f-gray-extra-dark">
                                <path fill-rule="evenodd"
                                    d="M3.758 32.018V6.28a3.68 3.68 0 0 1 7.165-1.185 8.02 8.02 0 0 0-3.662 10.552l.495 1.06a1 1 0 0 0 1.329.484l12.723-5.933a1 1 0 0 0 .484-1.329l-.494-1.06a8.023 8.023 0 0 0-8.99-4.445A5.682 5.682 0 0 0 1.758 6.28v25.738h2ZM19.985 9.714l.072.154-10.911 5.088-.072-.154a6.02 6.02 0 0 1 10.911-5.088Z"
                                    clip-rule="evenodd"></path>
                                <path
                                    d="m15.794 17.778.885 2.429-1.88.684-.884-2.429 1.88-.684Zm2.481 6.848-.884-2.43-1.88.685.885 2.429 1.88-.684Zm.713 1.989.884 2.43-1.88.683-.884-2.429 1.88-.684Zm1.981-8.6-1.293-2.24-1.732 1 1.293 2.24 1.732-1Zm1.058 1.828 1.292 2.239-1.732 1-1.292-2.239 1.732-1Zm3.642 6.307-1.293-2.24-1.732 1 1.292 2.24 1.733-1ZM23.61 13.259l1.483 2.117-1.638 1.147-1.483-2.117 1.638-1.147Zm4.214 6.007-1.483-2.117-1.638 1.147 1.483 2.117 1.638-1.147Zm1.238 1.778 1.482 2.117-1.638 1.147-1.482-2.117 1.638-1.147Zm-17.002.793-.67-2.497-1.931.518.669 2.497 1.931-.518Zm.556 2.095.67 2.497-1.932.518-.67-2.497 1.932-.518Zm1.894 7.089-.668-2.497-1.932.518.669 2.497 1.932-.518Z">
                                </path>
                            </svg>
                            <span multilang class="ubtt">{{ferienHauser?.bathrooms}} Badezimmer</span>
                        </div>
                    </li>
                    <li>
                        <div class="ubercontentwrapper">
                            @if(!ferienHauser?.petFriendly) {
                            <svg width="16" height="16" viewBox="0 0 32 32" icon="no_dogs"
                                class="fxsh0 w16 h16 f-gray-extra-dark">
                                <path d="m2.293 3.707 26 26 1.414-1.414-26-26-1.414 1.414Z"></path>
                                <path fill-rule="evenodd"
                                    d="m22.737 19.201.23-2.753 1.34-1.34 3.45.862a1 1 0 0 0 1.075-.415l2-3a1 1 0 0 0-.277-1.387l-5.476-3.65.411-2.877a1 1 0 0 0-.747-1.111l-2-.5a1 1 0 0 0-1.127.502l-4.282 8.088-1.794.385 1.684 1.684.865-.185 2.876 2.875-.08.97 1.852 1.852ZM22 14.586l-2.598-2.598 3.615-6.828.366.091-.373 2.608a1 1 0 0 0 .435.973l5.168 3.445-1.054 1.582-3.317-.83a1 1 0 0 0-.95.264L22 14.586Z"
                                    clip-rule="evenodd"></path>
                                <path
                                    d="m22.193 25.728-1.853-1.852L20.08 27h-2.233l-.86-5.164A1 1 0 0 0 16 21h-6a1 1 0 0 0-.986.836L8.153 27h-2.23l-.856-10.706 6.334-1.357-1.684-1.685-5.345 1.146-2.613-3.049-1.518 1.302 2.788 3.253.974 12.176A1 1 0 0 0 5 29h4a1 1 0 0 0 .986-.836L10.847 23h4.306l.86 5.164A1 1 0 0 0 17 29h4a1 1 0 0 0 .997-.917l.196-2.355Z">
                                </path>
                            </svg>
                            <span multilang class="ubtt">Haustiere nicht gestattet</span>
                            } @else {
                            <svg width="16" height="16" viewBox="0 0 32 32" icon="pets_allowed"
                                class="fxsh0 w16 h16 f-gray-extra-dark">
                                <path fill-rule="evenodd"
                                    d="M21.616 3.532a1 1 0 0 1 1.127-.502l2 .5a1 1 0 0 1 .747 1.111l-.41 2.877 5.475 3.65a1 1 0 0 1 .277 1.387l-2 3a1 1 0 0 1-1.075.415l-3.45-.863-1.34 1.341-.97 11.635A1 1 0 0 1 21 29h-4a1 1 0 0 1-.986-.836L15.153 23h-4.306l-.86 5.164A1 1 0 0 1 9 29H5a1 1 0 0 1-.997-.92L3.03 15.904.241 12.65l1.518-1.302 2.613 3.049 12.962-2.778 4.282-8.088Zm-2.214 8.456L22 14.586l1.293-1.293a1 1 0 0 1 .95-.263l3.316.829 1.054-1.582-5.168-3.445a1 1 0 0 1-.435-.973l.372-2.608-.365-.09-3.615 6.827Zm1.563 4.391-2.876-2.875-13.022 2.79L5.923 27h2.23l.86-5.164A1 1 0 0 1 10 21h6a1 1 0 0 1 .986.836L17.847 27h2.233l.885-10.62Z"
                                    clip-rule="evenodd"></path>
                            </svg>
                            <span multilang class="ubtt">Haustiere erlaubt</span>
                            }
                        </div>
                    </li>
                </ul>
            </div>
        </div>

        <div class="description">
            <div class="titlewrapper">
                <span multilang class="destitle">Ausstattung</span>
            </div>
            <div class="uberwrapper">
                <ul>
                    @for (item of ferienHauser?.amenities; track $index) {
                    @if(amenities[item].text?.length > 0) {
                    <li>
                        <div class="ubercontentwrapper">
                            <div multilang deeplMode='html' [innerHtml]="amenities[item].ico| safehtml"></div>
                            <span multilang class="ubtt"> {{amenities[item].text}}</span>
                        </div>
                    </li>
                    }
                    }
                </ul>
            </div>
        </div>

        <div class="description">
            <div class="titlewrapper">
                <span multilang class="destitle">Beschreibung</span>
            </div>
            <div class="desccontainer">
                <div [class.small]="!showMore">
                    <div class="f1rem" multilang deeplMode='html' [innerHtml]="ferienHauser?.description"></div>
                    <div class="deco" *ngIf="!showMore"></div>
                </div>
                <div class="moreShowwrapper noselect" (click)="showMoreDesc()">
                    <ng-container *ngIf="!showMore else showless">
                        <span multilang>Mehr anzeigen</span>
                        <mat-icon>expand_more</mat-icon>
                    </ng-container>

                    <ng-template #showless>
                        <span multilang>Weniger anzeigen</span>
                        <mat-icon>expand_less</mat-icon>
                    </ng-template>
                </div>
            </div>
        </div>

        <div class="description">
            <div class="titlewrapper">
                <span multilang class="destitle">Lage</span>
            </div>
            <div class="desccontainer">
                <ng-container *ngTemplateOutlet="lage">
                </ng-container>
            </div>
        </div>
    </div>
</ng-template>


<ng-template #attributesasarray let-cat="cat">
    <div class="mytab">
        <ng-container *ngTemplateOutlet="attributes; context:{attribute:cat?.attribute}"></ng-container>
    </div>
</ng-template>

<ng-template #attributesasobjView let-attribute="attribute">
    <div class="mytab">
        <ng-container *ngTemplateOutlet="attributesView; context:{att:attribute}"></ng-container>
    </div>
</ng-template>

<ng-template #attributes let-attribute="attribute">
    <ng-container *ngFor="let att of attribute">
        <ng-container *ngTemplateOutlet="attributesView; context:{att:att}"></ng-container>
    </ng-container>
</ng-template>

<ng-template #attributesViewMobile let-att="att">

</ng-template>

<ng-template #attributesView let-att="att">
    <ng-container *ngIf="(desktopTemplate !== 'xs' && desktopTemplate !== 'sm') else mobile">
        <div class="lookup bord">
            <mat-icon class="uberico">check</mat-icon>
            <span multilang class="tttile">{{att?.title}}</span>
            <ng-container *ngIf="att?.type === 'lookup'; else unic">
                <ng-container *ngIf="att?.lookup?.length > 0; else asobj">
                    <div class="lvalue">
                        <ng-container *ngFor="let look of att?.lookup;let last = last;">
                            {{look?.title}}<ng-container *ngIf="!last">{{', '}}</ng-container>
                        </ng-container>
                    </div>
                </ng-container>
                <ng-template #asobj>
                    <div class="lvalue" multilang deeplMode='html' [innerHtml]="att?.lookup?.title"></div>
                </ng-template>
            </ng-container>
            <ng-template #unic>
                <div class="lvalue" multilang deeplMode='html'
                    [innerHtml]="(att?.text + ' ' + (att?.unit ? att.unit : '') ) | linkifyEdom"
                    *ngIf="att?.text?.length > 0"></div>
            </ng-template>
        </div>
    </ng-container>

    <ng-template #mobile>
        <div class="lookupMobile bord">
            <mat-icon class="uberico">check</mat-icon>
            <span multilang class="tttile">{{att?.title}}</span>
            <ng-container *ngIf="att?.type === 'lookup'; else unic">
                <ng-container *ngIf="att?.lookup?.length > 0; else asobj">
                    <div class="lvalueMobile">
                        <ng-container *ngFor="let look of att?.lookup;let last = last;">
                            {{look?.title}}<ng-container *ngIf="!last">{{', '}}</ng-container>
                        </ng-container>
                    </div>
                </ng-container>
                <ng-template #asobj>
                    <div class="lvalueMobile" multilang deeplMode='html' [innerHtml]="att?.lookup?.title"></div>
                </ng-template>
            </ng-container>
            <ng-template #unic>
                <div class="lvalueMobile" multilang deeplMode='html'
                    [innerHtml]="(att?.text + ' ' + (att?.unit ? att.unit : '') ) | linkifyEdom">
                </div>
            </ng-template>
        </div>
    </ng-template>
</ng-template>

<ng-template #lage>
    <div class="mymap">
        <div id="map" class="cc1"></div>
    </div>
</ng-template>